import { useState } from 'react';
import apiService from '../../axios/apiService';

const useInvoiceTransactionStatus = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const getData = async (invoiceId) => {
    // Fetch data
    try {
      setLoading(true);
      const response = await apiService.getInvoiceTransactionStatus(invoiceId);
      response && setData(response); // update data state
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    getData,
  };
};

export default useInvoiceTransactionStatus;
